const routes = [
    {
        name: 'editarDadosEmpresa',
        path: '/assinatura_digital/configuracoes/dados_empresa',
        component: () => import('../views/DadosEmpresa')
    },
    {
        name: 'listarLojas',
        path: '/assinatura_digital/lojas',
        alias: '/assinatura_digital/lojas/index',
        component: () => import('../views/Listar')
    },
    {
        name: 'adicionarLoja',
        path: '/assinatura_digital/lojas/adicionar',
        component: () => import('../views/Adicionar'),
        meta: {
            fullScreen: true
        }
    },
    {
        name: 'editarLoja',
        path: '/assinatura_digital/lojas/editar/:id',
        component: () => import('../views/Editar'),
        meta: {
            fullScreen: true
        }
    },
    {
        name: 'visualizarLoja',
        path: '/assinatura_digital/lojas/visualizar/:id',
        component: () => import('../views/Visualizar'),
    }
]

export default routes